import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LinkRequestChannelContent from './LinkRequestChannelContent';

export class TelegramChannelContentComponent extends Component {
    static propTypes = {
        channelState: PropTypes.object.isRequired,
    };

    render() {
        const { channelState } = this.props;
        return <LinkRequestChannelContent type="telegram" channelState={channelState} />;
    }
}

export default connect(null, null, null, { forwardRef: true })(TelegramChannelContentComponent);
